import { motion, type MotionProps } from "framer-motion";
import type { ReactNode } from "react";

interface MotionDivProps extends MotionProps {
  children: ReactNode;
  delay?: number;
  direction?: "up" | "down" | "left" | "right";
  className?: string;
}

export const MotionDiv = ({
  children,
  delay = 0,
  direction = "up",
  className,
  ...props
}: MotionDivProps) => {
  const getDirection = () => {
    switch (direction) {
      case "up":
        return { y: 30 };
      case "down":
        return { y: -30 };
      case "left":
        return { x: 30 };
      case "right":
        return { x: -30 };
      default:
        return { y: 30 };
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, ...getDirection() }}
      className={className}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      transition={{
        duration: 0.6,
        ease: "easeOut",
        delay,
      }}
      viewport={{ once: true, amount: 0.2 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
